import React, { useState } from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, rectSortingStrategy } from '@dnd-kit/sortable';

const DragDrop = ({ items, onUpdate }) => {
    const [currentItems, setCurrentItems] = useState(items);

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (active.id !== over.id) {
            setCurrentItems((items) => {
                const oldIndex = items.indexOf(active.id);
                const newIndex = items.indexOf(over.id);
                const newItems = arrayMove(items, oldIndex, newIndex);
                console.log(newItems);
                onUpdate(newItems);
                return newItems;
            });
        }
    };

    return (
        <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
        >
            <SortableContext
                items={currentItems}
                strategy={rectSortingStrategy}
            >
                {currentItems.map((id, index) => (
                    <SortableItem key={id} id={id} index={index} />
                ))}
            </SortableContext>
        </DndContext>
    );
};

const SortableItem = ({ id, index }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : '',
        transition,
        padding: '16px',
        margin: '8px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        backgroundColor: '#fff',
        cursor: 'grab',
        color: 'black'
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {index + 1} - {id}
        </div>
    );
};

export default DragDrop;